import type { ListStudentsParams } from "@api/students"

export const studentKeys = {
  all: ["students"] as const,
  lists: () => [...studentKeys.all, "list"] as const,
  byClassroom: (classroomId: string) =>
    [...studentKeys.lists(), { classroom: classroomId }] as const,
  rosterPage: (params: ListStudentsParams) => [...studentKeys.lists(), "roster", params] as const,
  details: () => [...studentKeys.all, "detail"] as const,
  detail: (id: string) => [...studentKeys.details(), id] as const,
  // PRD-09: per-student detail page payload (separate cache from `detail(id)`
  // because the envelope is much wider — student + classroom + tasks + activity).
  progress: (id: string) => [...studentKeys.all, "progress", id] as const,
}
